import { render } from "./houseDetail.vue?vue&type=template&id=6d877eb4"
import script from "./houseDetail.vue?vue&type=script&lang=js"
export * from "./houseDetail.vue?vue&type=script&lang=js"
script.render = render

export default script